import axios from "axios"
import { getEnv, EnvKeysEnum } from "Utils/environment"

const authInstance = axios.create({
  baseURL: getEnv(EnvKeysEnum.BroccAuthApi),
})

export default authInstance
